import { StoreAction, XmAction } from 'store/actions';
import { ByodEligibility, EligibilityByod, EligibilityByodStatus } from './models';

export function byodEligibilityReducer(state: ByodEligibility, action: XmAction<ByodEligibility>): ByodEligibility {
    switch (action.type) {
        case StoreAction.GET_BYOD_ELIGIBILITY:
        case StoreAction.CLEAR_BYOD_ELIGIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function eligibilityByodReducer(state: EligibilityByod, action: XmAction<EligibilityByod>): EligibilityByod {
    switch (action.type) {
        case StoreAction.POST_ELIGIBILITY_BYOD:
            return action.payload;
        default:
            return state;
    }
}

export function eligibilityByodStatusReducer(state: EligibilityByodStatus, action: XmAction<EligibilityByodStatus>): EligibilityByodStatus {
    switch (action.type) {
        case StoreAction.GET_ELIGIBILITY_BYOD_STATUS:
            return action.payload;
        default:
            return state;
    }
}
